import React from 'react';
import S from 'common/service/sanctuary';
import * as R from 'ramda';
import { func } from 'prop-types';
import { RadioField } from 'common/mdc/form';
import criteriaShape from './criteriaShape';

import { EQUALS } from './operator';

import SearchConstraint, { constraintShape } from './constraint';

export const translateConstraint = criteria => constraint => (
  constraint.value ?
    S.map(S.prop('label'), S.find(R.propEq('value', constraint.value), criteria.values)) :
    S.Nothing);

const Choice = ({
  constraint,
  onValueChange,
  criteria,
  ...props
}) => (
  <SearchConstraint
    {...props}
    className="choice-criteria"
    constraint={constraint}
    operators={[
      EQUALS,
    ]}
    removable={false}
    clearAvailable={!criteria.singleConstraint}
  >
    <div className="choice-radio">
      {criteria.values.map((value, idx) => (
        <RadioField
          id={`constraint-${value.value}`}
          // eslint-disable-next-line react/no-array-index-key
          key={`constraint-${idx}`}
          label={value.label}
          value={value.value}
          name={criteria.property}
          onChange={e => onValueChange(e.target.value)}
          checked={constraint.value === value.value}
        />
      ))}
    </div>
  </SearchConstraint>
);

Choice.propTypes = {
  criteria: criteriaShape.isRequired,
  constraint: constraintShape.isRequired,
  onValueChange: func.isRequired,
};

export default Choice;
